module.exports = __webpack_public_path__ + "static/mccarthy-hall-5-c392fa10b151cda5f24099046dfa3d45.jpg";